'use client';

import Link from 'next/link';
import { ArrowLeft, Home, Bot } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-indigo-100 flex items-center justify-center px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full text-center">
        {/* Logo */}
        <div className="flex items-center justify-center mb-8">
          <Bot className="h-12 w-12 text-primary-600 mr-3" />
          <span className="text-3xl font-bold text-foreground">AI for CSM</span>
        </div>
        
        {/* 404 Error */}
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-primary-600 mb-4">404</h1>
          <h2 className="text-2xl font-bold text-foreground mb-2">Page not found</h2>
          <p className="text-muted-foreground">
            Sorry, we couldn't find the page you're looking for.
          </p>
        </div>
        
        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            href="/"
            className="bg-primary-600 hover:bg-primary-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors flex items-center justify-center"
          >
            <Home className="h-4 w-4 mr-2" />
            Go home
          </Link>
          <button
            onClick={() => window.history.back()}
            className="border-2 border-input hover:border-input text-foreground px-6 py-3 rounded-lg font-semibold transition-colors flex items-center justify-center"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Go back
          </button>
        </div>
        
        {/* Help Text */}
        <div className="mt-8 text-sm text-muted-foreground">
          <p>
            If you believe this is an error, please{' '}
            <a href="mailto:support@aiforcsm.com" className="text-primary-600 hover:text-primary-500 font-medium">
              contact support
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
